import { megaFavicon } from '../api';

/**
 * Updates the favicon dynamically
 */
export const updateFavicon = () => {
  const link = document.querySelector("link[rel*='icon']") || document.createElement('link');
  link.type = 'image/png';
  link.rel = 'icon';
  link.href = megaFavicon;
  document.getElementsByTagName('head')[0].appendChild(link);
};
